/**
 * PrepareUserInfomationPage
 * ========================================
 *          Mo=dify
 * ========================================
 *  #MDF20230214
 *  issue:
 *   DPO (Fac of Engineeing director) notice after logged-in then not redirect to the system!
 *   check init menu of back office perm.. error!
 *   initialMenuBackOfUser is undifined (initialMenuBackOfUser.path error)
 *  couse of because permission.level.includes(menu.permissionLevel[0]) not found
 *     - permission.level = [0, 3]
 *     - menu.permissionLevel = [1,2,3]
 */
import React, { useState, useEffect } from 'react';

import clsx from 'clsx';

// import axios
import axios from 'axios';

// import material-ui core/style
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { red, green } from '@material-ui/core/colors';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import PersonOutlineSharpIcon from '@material-ui/icons/PersonOutlineSharp';

// import constanst
import { server, sysURL } from '../../../constants';

// import routers constants
import {
  routers,
  listMenuBackOf,
  listPermissionLevelBackOf,
} from '../../../routers';

// import uitils/utils
import { userProfiler, mergeArray, logger } from '../../../utils/utils';
import { useHandleClientError } from '../../../utils/HttpClient';

// import info, users data
import { info, users } from '../../../data';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapper: {
    margin: theme.spacing(10, 10, 5, 10),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonFail: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -8,
    left: -8,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));
const PREPAREING = 'preparing';
const PREPAREING_SUCCESS = 'preparing success';
const PREPAREING_FAIL = 'preparing fail';
// UpdateUserInformationPage() (Component)
// Path:
const PrepareUserInformationPage = ({ history }) => {
  const classes = useStyles();
  const handleClientError = useHandleClientError();
  const UDUSER_CONTENT_ID = 'update-user-content';
  const [preparing, setPreparing] = useState(false);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (!preparing) {
      setSuccess(null);
      setPreparing(true);
    }
  }, []);

  let status = null;
  if (preparing) {
    status = PREPAREING;
  } else {
    if (success) {
      status = PREPAREING_SUCCESS;
    }
    if (!success) {
      status = PREPAREING_FAIL;
    }
  }
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  async function preparer() {
    try {
      // call api/info for change databaseContext connection from dev to current server
      await info.getInfoNoVersion();

      let respAccessToken = await axios.get(sysURL.accessToken);
      let { data } = respAccessToken;

      if (data.status === true) {
        // jsSnackbar("Data authorized");

        // Set tokenAccess to localStorage
        localStorage.setItem(server.ACCESS_TOKEN_KEY, data.tokenAccess);

        // Updatep hri-personal data to user model.
        await users.updateUser();

        // Get user profile (consis of user, permission) and set to localStorage
        let { user, permission } = await users.userProfile();

        // ** Fixed full permission (Please remove before up to production), fo Test admin add [8, 9] to mergeArray parameter
        // permission.level = mergeArray([permission.level, []]);

        userProfiler.setToLocal({ user, permission });

        // State - success (& preparing flase)
        setSuccess(true);
        setPreparing(false);

        // Redirect to back/front office permission
        setTimeout(() => {
          // Check user has back office permission or not.
          if (
            permission.level.some(
              (elem) => listPermissionLevelBackOf.indexOf(elem) > -1
            )
          ) {
            // Condition = user has back office perm.

            /**
             * ======================================
             * check init menu of back office perm..
             * ======================================
             */

            // < Commented code bellow is the issue of #MDF20230214 >

            // let initialMenuBackOfUser = listMenuBackOf.find((menu) =>
            //   permission.level.includes(menu.permissionLevel[0])
            // );

            // #MDF20230214 (Fix issue DPO notice after logged-in then not redirect to the system!)
            let initialMenuBackOfUser = listMenuBackOf.find((menuItem) =>
              permission.level.some(
                (levelItem) => menuItem.permissionLevel.indexOf(levelItem) > -1
              )
            );
            history.push(initialMenuBackOfUser.path);

            // Condition = user has only front office permission.
          } else {
            history.push(routers.frontOf.main.path);
          }
        }, 2000);
      } else {
        throw data;
      }
    } catch (error) {
      // If error then set state - success fail (& preparing flase)
      setSuccess(false);
      setPreparing(false);

      // Open dialog notice error
      handleClientError(error);
    }
  }

  useEffect(() => {
    preparer();
  }, []);

  // console.log({preparing})
  return (
    <div className={classes.root}>
      <Box className={classes.item}>
        <div className={classes.wrapper}>
          {status != PREPAREING_FAIL && (
            <Fab
              aria-label="save"
              size="large"
              color="primary"
              className={buttonClassname}
              style={{ height: '85px', width: '85px' }}
            >
              {status === PREPAREING && (
                <PersonOutlineSharpIcon style={{ fontSize: '57px' }} />
              )}
              {status === PREPAREING_SUCCESS && (
                <CheckIcon style={{ fontSize: '57px' }} />
              )}
            </Fab>
          )}
          {preparing && (
            <CircularProgress size={100} className={classes.fabProgress} />
          )}
        </div>
      </Box>
      <Box
        className={classes.item}
        id={UDUSER_CONTENT_ID}
        style={{ fontSize: '16px', color: '#666' }}
      >
        {status === PREPAREING && <div>โปรดรอสักครู่...</div>}
        {status === PREPAREING_SUCCESS && <div>เข้าสู่ระบบ</div>}
        {status === PREPAREING_FAIL && (
          <div align="center">
            <h4 style={{ color: 'red' }}>
              เกิดข้อผิดพลาดในการเตรียมข้อมูลผู้ใช้งาน
            </h4>
            <p>
              <a href="/login">กลับสู่ Login</a> เพื่อ ลองใหม่อีกครั้ง
            </p>
          </div>
        )}
      </Box>
    </div>
  );
};

export default PrepareUserInformationPage;
